import React, { useEffect } from "react";

import {
  About,
  Footer,
  Header,
  Skills,
  Testimonial,
  Work,
  Process,
} from "./container";
import { Navbar } from "./components";
import "./App.scss";

const App = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonial />
      <Process />
      <Footer />
    </div>
  );
};

export default App;
